import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=295a1daf&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=295a1daf&prod&scoped=true&lang=css"
import style1 from "./faq.vue?vue&type=style&index=1&id=295a1daf&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295a1daf",
  null
  
)

export default component.exports